'use client';
import Link from 'next/link';
import { isIos } from '@/helpers/common';
import { useNavigation } from '@/hooks/navigation';
import { useCMSConfig } from '@/modules/common';
import { useGetCommonStore } from '@/store';
import { ImageComponent } from '../../../../components/Image';

interface LinkProps {
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

export const IOSLink = ({ onClick }: LinkProps) => {
  const { generateLink } = useNavigation();
  return (
    <Link
      aria-label="App Store link"
      className="button"
      href={generateLink('/mobile-app')}
      onClick={onClick}
    >
      <ImageComponent
        alt="App Store link"
        className="ios-img"
        height={40}
        src="/app/ios_v2.webp"
        width={144}
      />
    </Link>
  );
};

export const ANDROIDLink = ({ onClick }: LinkProps) => {
  const { generateLink } = useNavigation();
  return (
    <Link
      aria-label="Google Play link"
      className="button"
      href={generateLink('/mobile-app')}
      onClick={onClick}
    >
      <ImageComponent
        alt="Google Play link"
        height={40}
        src="/app/android.webp"
        width={135}
      />
    </Link>
  );
};

export const AppLinks = () => {
  const useCommonStore = useGetCommonStore();

  const isMobileDevice = useCommonStore.use.isMobileDevice();
  const { mobileAppCMS } = useCMSConfig();

  if (!mobileAppCMS) return null;

  if (isMobileDevice) {
    if (!isIos() && mobileAppCMS.showAndroid) {
      return <ANDROIDLink />;
    }
    if (isIos()) {
      return <IOSLink />;
    }
    return null;
  }

  return (
    <>
      {(isIos() || !isMobileDevice) && <IOSLink />}
      {mobileAppCMS.showAndroid && <ANDROIDLink />}
    </>
  );
};
